import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetGeneralStatuses = (studentId, enabled) => {
    const {
        isLoading, data: general, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: [`student/${studentId}/enrolment`],
        queryFn: () => axiosManager.get$(`/parent/api/students/${studentId}/enrolment`).then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        keepPreviousData: true,
        enabled: !!enabled && !!studentId,
    });

    return {
        isLoading,
        isRefetching,
        general: general || {},
        error,
        refetch,
    };
};
